import { render, staticRenderFns } from "./hotelSetting.vue?vue&type=template&id=a13ae906&"
import script from "./hotelSetting.vue?vue&type=script&lang=js&"
export * from "./hotelSetting.vue?vue&type=script&lang=js&"
import style0 from "./hotelSetting.vue?vue&type=style&index=0&id=a13ae906&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports